import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DonationsRoutingModule } from '../donations/donations-routing.module';
import { MaterialModule } from '../shared/material.module';
import { SharedModule } from '../shared/shared.module';
import { CustomCheckoutComponent } from './custom-checkout.component';
@NgModule({
  declarations: [CustomCheckoutComponent],
  exports: [CustomCheckoutComponent],
  imports: [
    CommonModule,
    DonationsRoutingModule,
    SharedModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class CustomCheckout {}
